import React from "react";
import './StyleLoader.scss';

const StyleLoader = (props) => {
    return (
        <>
            <div className="style-loader-wrapper">
                {/* <div className="styles-tags-wrapper">
                    <div className="style-tags">
                        <button className="vg_skeleton"></button>
                        <button className="vg_skeleton"></button>
                        <button className="vg_skeleton"></button>
                        <button className="vg_skeleton"></button>
                        <button className="vg_skeleton"></button>
                        <button className="vg_skeleton"></button>
                    </div>
                    <div>
                        <div className="sort-toggle dropdown-toggle">
                            <div className="vg_skeleton"></div>
                        </div>
                    </div>
                </div> */}
                <div className="styles-cards-wrapper styles-cards-wrapper-business onlystyles js-hasScroll">
                    <>
                        {props.styleList.map((d,index) => {
                            return (
                                <div className="styles-card-col" key={index}>
                                    <div className="styles-card">
                                        <div className="styles-card-thum-frame vg_skeleton">
                                            
                                        </div>
                                        <div className="styles-card-item">
                                            <h3>
                                                <div className="vg_skeleton"></div>
                                                <div className="badge badge-inactive">
                                                    <div className="vg_skeleton"></div>
                                                </div>
                                            </h3>
                                            <p className="vg_skeleton"></p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                        }
                    </>
                </div>
            </div>
        </>
    )
}

export default StyleLoader;